import axios from '../../common/utils/interceptor';
import { WorkflowItemCode, apiUrls, defaultBranding } from '../../constants';
import { WorkflowItem } from '../../store/interfaces';
import localizeContentMapper from '../../common/utils/localizeContentMapper';
import { SessionStore } from '../../constants/sessionStore';
import { getCookie } from '../../common/utils/cookies';
import { combineTasksAndProductList } from '../../common/utils/combineTasksAndProductList';
import { defaultTemplateProvider, templateProvider } from '../../store/providers/templateProvider';
import {
  currentWorkflowItemProvider,
  firstWorkflowItemProvider,
} from '../../store/providers/currentWorkflowItemProvider';
import updateTemplateWithAccessibilitySettings from './updateTemplateWithAccessibilitySettings';
import { workflowSessionProvider } from '../../store/providers/workflowSessionProvider';
import { getStore } from '../../store';

/** Api call to revalidate session */
export const reValidateSession = async (queryParams = ''): Promise<{ data?: WorkflowItem; error: string }> => {
  const res = { data: undefined, error: '' };
  const tcPlusFlow = getCookie('TcPlusFlag') === '1';
  const { setTemplate } = templateProvider();
  const { setFirstWorkflowItem } = firstWorkflowItemProvider();
  const { setDefaultTemplate } = defaultTemplateProvider();
  const { updateCurrentWorkflowItem } = currentWorkflowItemProvider();
  const { setWorkflowSession } = workflowSessionProvider();

  try {
    let url = apiUrls.REVALIDATE_SESSION;
    if (queryParams !== '') {
      url = `${url}?${queryParams}`;
    }
    const { data } = await axios.get(url);

    if (data.IsError) {
      res.error = data.Message;
    } else {
      const isBasicFlow = getCookie('BasicFlow') === '1';
      if (tcPlusFlow && !isBasicFlow) {
        data.workflowItem.configuration = combineTasksAndProductList(data.workflowItem.configuration);
      }
      if (!(isBasicFlow && queryParams)) {
        if (data.workflowItem.code === WorkflowItemCode.LANDING_PAGE) {
          setFirstWorkflowItem(data.workflowItem);
        }
        updateCurrentWorkflowItem(data.workflowItem);
      }

      res.data = data.workflowItem;

      if (data.template && data.template.id) {
        // Fallback to default settings in case its null
        const parsedTemplateSettings = data.template.settings ? JSON.parse(data.template.settings) : defaultBranding;
        let companyBranding = getStore().state.companySettings.companyBranding;
        companyBranding = companyBranding && JSON.parse(companyBranding);

        const selectedAccessibilityTheme = sessionStorage.getItem(SessionStore.selectedAccessibilityTheme);
        const selectedAccessibilityId = selectedAccessibilityTheme && JSON.parse(selectedAccessibilityTheme);

        let templateSettings = parsedTemplateSettings;

        const template = {
          ...data.template,
          settings: localizeContentMapper(templateSettings, data.template.localizedContentMap),
        };

        if (isBasicFlow && companyBranding) {
          templateSettings = companyBranding;
          template.settings = localizeContentMapper(templateSettings, data.template.localizedContentMap);
        }

        if (isBasicFlow && selectedAccessibilityTheme && selectedAccessibilityId !== 1) {
          setTemplate(updateTemplateWithAccessibilitySettings(template, selectedAccessibilityId));
        } else {
          setTemplate(template);
        }
        setDefaultTemplate(template);
      }

      if (data.workflowSession) {
        setWorkflowSession(data.workflowSession);
        if (data.workflowSession?.formStatus) {
          sessionStorage.setItem(SessionStore.formStatus, data.workflowSession?.formStatus);
        }
      }
    }
  } catch (e) {
    res.error = 'error';
    if (e) {
      res.error = (e.data && e.data.Message) || e.message;
    }
  }
  return res;
};
